import { all } from "@redux-saga/core/effects";

import { rolesEntriesSagas } from "./Entities/sagas";

export function* rolesSaga() {
    yield all([
        rolesEntriesSagas()
    ]);
}